import React, { FC } from "react";
import { FormBaseType } from "@green0meter/api-client";
import { useParams } from "react-router";

import { useGetAvailableForms } from "@api";
import CollectDataTable from "@components/main/co2/hub/CollectData/components/CollectDataTable";
import { CircularProgress } from "@components/base";
import { useUserStore } from "@store/user";

const SupplierCollectData: FC = () => {
  const { procurementId } = useParams<{ procurementId: string }>();
  const { user } = useUserStore();

  if (!procurementId) {
    return <CircularProgress />;
  }
  const { availableForms = [], isFetchingAvailableForms } = useGetAvailableForms(
    user,
    [FormBaseType.ProcurementSupplier],
    procurementId,
  );

  return (
    <CollectDataTable
      formBaseType={FormBaseType.ProcurementSupplier}
      forms={availableForms}
      isLockDeleteActionsDisabled
      procurementId={procurementId}
      isFetchingAvailableForms={isFetchingAvailableForms}
    />
  );
};

export default SupplierCollectData;
